import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  title: {
    font: "normal 600 18px/24px Inter",
    color: "#465869",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  filters: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  skeleton: {
    minHeight: "80vh",
  },
  body: {
    padding: "24px",
  },
}));

export default styles;
